import React from 'react';

interface SkeletonLoaderProps {
  className?: string;
  variant?: 'card' | 'chart' | 'table' | 'text';
  lines?: number;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  className = '',
  variant = 'card',
  lines = 3
}) => {
  const baseClasses = "animate-pulse bg-gray-200 dark:bg-gray-700 rounded";

  if (variant === 'card') {
    return (
      <div className={`bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 ${className}`}>
        <div className="flex items-start justify-between mb-4">
          <div className={`${baseClasses} h-6 w-32`}></div>
          <div className={`${baseClasses} h-8 w-8 rounded-full`}></div>
        </div>
        <div className={`${baseClasses} h-10 w-24 mb-2`}></div>
        <div className={`${baseClasses} h-4 w-40`}></div>
      </div>
    );
  }

  if (variant === 'chart') {
    return (
      <div className={`bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 ${className}`}>
        <div className={`${baseClasses} h-6 w-32 mb-4`}></div>
        <div className={`${baseClasses} h-64 w-full`}></div>
      </div>
    );
  }

  if (variant === 'table') {
    return (
      <div className={`bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 ${className}`}>
        <div className={`${baseClasses} h-6 w-32 mb-4`}></div>
        {[...Array(lines)].map((_, i) => (
          <div key={i} className="flex gap-4 mb-3">
            <div className={`${baseClasses} h-4 flex-1`}></div>
            <div className={`${baseClasses} h-4 w-20`}></div>
            <div className={`${baseClasses} h-4 w-20`}></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`${className}`}>
      {[...Array(lines)].map((_, i) => (
        <div key={i} className={`${baseClasses} h-4 w-full mb-2`}></div>
      ))}
    </div>
  );
};

export default SkeletonLoader;